import HistoryIcon from "@mui/icons-material/History";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { strLang } from "../../functions/strLang";
import MiniButton from "../../components/MiniButton";
import { isEditor } from "../../functions/isEditor";

export default function ButtonsList({ data, openRecords, editTer, askDelete }) {
  const { ID = 0, NOM = "", TILE, DESCRIP, TOTAL, TERGROUP } = data || {};
  const specialStyle = { display: "inline-block", marginRight: 5 };
  return (
    <div
      style={{
        width: "100%",
        marginTop: 5,
        marginBottom: 5,
      }}
    >
      {ID > 0 && (
        <>
          <MiniButton
            title={strLang("records")}
            Icon={HistoryIcon}
            onClick={() => openRecords(ID, NOM)}
            style={specialStyle}
          />
          {isEditor && (
            <MiniButton
              title={strLang("edit")}
              Icon={DriveFileRenameOutlineIcon}
              onClick={() =>
                editTer({
                  id: ID,
                  name: NOM,
                  tile: TILE,
                  descrip: DESCRIP,
                  group: TERGROUP,
                })
              }
              style={specialStyle}
            />
          )}
          {isEditor && ID > 0 && TOTAL === 0 && (
            <MiniButton
              title={strLang("delete")}
              Icon={DeleteForeverIcon}
              onClick={() => askDelete(ID, NOM)}
              color="red"
              style={specialStyle}
            />
          )}
        </>
      )}
    </div>
  );
}
